import { render } from "./informazioni.vue?vue&type=template&id=7dc818ed"
import script from "./informazioni.vue?vue&type=script&lang=js"
export * from "./informazioni.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__